import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import equalHeight from '../functions/equalHeight';
import BackToTop from '../components/chunks/BackToTop';
import PropTypes from 'prop-types';
import {APP_TITLE, MEDIA_URL} from '../constants/config';
import { Helmet } from 'react-helmet';

class Surfaces extends React.Component{
    constructor(props){
        super(props);
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        equalHeight(document.querySelectorAll('.block_item header'));
    }

    render(){
        return(
            <div id="surfaces">
                <Helmet>
                    <title>Choose a Surface | {APP_TITLE}</title>
                </Helmet>
                <h2 className="entry-title">What type of surface do you have?</h2>
                <div className="row entry">
                    {this.props.surfaces.map((b, i) =>
                        <div key={i} className="col-12 col-sm-6 col-lg-4 col-xl-3">
                            <Link to={"/" + b.slug + "/options"} className="block_item">
                                <header className="py-3 px-4"><h4 className="mb-1 text-uppercase">{b.name}</h4></header>
                                <div>
                                    <img src={MEDIA_URL + "floors/" + b.slug + ".jpg"} className="img-fluid" alt={b.name}/>
                                </div>
                            </Link>
                        </div>
                    )}
                </div>
                <BackToTop />
            </div>
        );
    }
}

// Maps state from store to props
const mapStateToProps = (state) => {
    return {
        // You can now say this.props.books
        surfaces: state.surfaces
    };
};

Surfaces.propTypes = {
    surfaces: PropTypes.array,
};

// Use connect to put them together
export default connect(mapStateToProps)(Surfaces);


// WEBPACK FOOTER //
// ./src/components/Surfaces.js